import { getLocalApi } from 'app/shared/api/localApi';
import apiConfig from 'app/api/apiConfig.json';

export type ProductsLookupType =
  | 'Course'
  | 'AccommodationRoom'
  | 'AddOn'
  | 'Transfer'
  | 'Package'
  | 'Fee';

export type ProductLookupRow = {
  id: number;
  name: string;
  typeId?: number;
  active: boolean;
};

function extractArray(data: unknown): unknown[] {
  if (Array.isArray(data)) return data;
  const o = data as Record<string, unknown> | null;
  if (!o) return [];
  const nested = o.data ?? o.items ?? o.result ?? o.Data;
  return Array.isArray(nested) ? nested : [];
}

function mapLookupRow(raw: Record<string, unknown>): ProductLookupRow {
  const id = Number(
    raw.productId ?? raw.ProductId ?? raw.id ?? raw.Id ?? raw.productID ?? 0
  );
  const name = String(
    raw.productName ?? raw.ProductName ?? raw.name ?? raw.Name ?? ''
  );
  const typeRaw = raw.typeId ?? raw.TypeId ?? raw.addOnTypeId ?? raw.accommodationTypeId;
  const typeIdNum = typeRaw != null ? Number(typeRaw) : NaN;
  const activeRaw = raw.active ?? raw.Active;
  const active = activeRaw === undefined ? true : activeRaw !== false;
  return {
    id: Number.isFinite(id) && id > 0 ? Math.trunc(id) : 0,
    name,
    ...(Number.isFinite(typeIdNum) && typeIdNum > 0 ? { typeId: Math.trunc(typeIdNum) } : {}),
    active,
  };
}

export async function getProductsLookup(type: ProductsLookupType): Promise<ProductLookupRow[]> {
  const localApi = await getLocalApi();
  const base = (apiConfig as Record<string, string>).products_lookup;
  if (!base) {
    throw new Error('products_lookup is not configured in apiConfig');
  }
  const url = `${base}?type=${encodeURIComponent(type)}`;
  return localApi.fetchList(
    url,
    (item) => mapLookupRow(item as Record<string, unknown>),
    `Failed to fetch product lookup (${type})`,
    extractArray
  );
}